export const SETTLEMENT_TYPE_PAYMENT = "payment";
export const SETTLEMENT_TYPE_DISCOUNT = "discount";
export const SETTLEMENT_TYPE_KNOCK_OFF = "knock_off";

export function normalizeSettlementType(value) {
  const raw = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  if (raw === SETTLEMENT_TYPE_DISCOUNT) {
    return SETTLEMENT_TYPE_DISCOUNT;
  }
  if (raw === SETTLEMENT_TYPE_KNOCK_OFF || raw === "knockoff") {
    return SETTLEMENT_TYPE_KNOCK_OFF;
  }
  return SETTLEMENT_TYPE_PAYMENT;
}

export function getSettlementTypeLabel(value) {
  const type = normalizeSettlementType(value);
  if (type === SETTLEMENT_TYPE_DISCOUNT) {
    return "Discount";
  }
  if (type === SETTLEMENT_TYPE_KNOCK_OFF) {
    return "Knock Off";
  }
  return "Payment";
}

export function isPaymentSettlement(value) {
  if (value && typeof value === "object") {
    return normalizeSettlementType(value.type || value.settlementType || value.transactionType) === SETTLEMENT_TYPE_PAYMENT;
  }
  return normalizeSettlementType(value) === SETTLEMENT_TYPE_PAYMENT;
}

export function getSettlementSummary(totalAmount, settlements) {
  let paidAmount = 0;
  let discountAmount = 0;
  let knockOffAmount = 0;

  for (const settlement of Array.isArray(settlements) ? settlements : []) {
    const amount = Number(settlement?.amount) || 0;
    if (amount <= 0) continue;
    const type = normalizeSettlementType(
      settlement?.type || settlement?.settlementType || settlement?.transactionType
    );
    if (type === SETTLEMENT_TYPE_DISCOUNT) {
      discountAmount += amount;
      continue;
    }
    if (type === SETTLEMENT_TYPE_KNOCK_OFF) {
      knockOffAmount += amount;
      continue;
    }
    paidAmount += amount;
  }

  const normalizedTotalAmount = +Number(totalAmount || 0).toFixed(2);
  const normalizedPaidAmount = +paidAmount.toFixed(2);
  const normalizedDiscountAmount = +discountAmount.toFixed(2);
  const normalizedKnockOffAmount = +knockOffAmount.toFixed(2);
  const settledAmount = +(normalizedPaidAmount + normalizedDiscountAmount + normalizedKnockOffAmount).toFixed(2);
  const pendingAmount = Math.max(0, +(normalizedTotalAmount - settledAmount).toFixed(2));

  return {
    totalAmount: normalizedTotalAmount,
    paidAmount: normalizedPaidAmount,
    discountAmount: normalizedDiscountAmount,
    knockOffAmount: normalizedKnockOffAmount,
    settledAmount,
    pendingAmount,
  };
}
